import React, { ReactElement, useState, ReactNode } from 'react';
import { orderBy } from 'lodash-es';
import MultiListPagination from './MultiListPagination';
import MultiListTable from './MultiListTable';
import MultiListCard from './MultiListCard';

export interface ColumnProps {
    keyName: string;
    header: ReactElement | string;
    renderFunction?: (value: any, row: any) => ReactNode;
    onClick?: (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
    width?: string;
    // defaultSortedBy?: boolean;
    // defaultSortType?: 'asc' | 'desc';
}

const Column: React.FC<ColumnProps> = () => {
    return null;
};

export interface OptionsColumnProps {
    keyName?: string;
    header?: ReactElement | string;
    renderFunction?: (row: any, index: number) => ReactNode;
}

const OptionsColumn: React.FC<OptionsColumnProps> = () => {
    return null;
};

export const getHeaderKey = (keyName) => {
    if (keyName) return keyName;
    return '__options';
};

export type TableProps = {
    pageSize?: number;
    data: any[];
    startPage?: number;
    children: ReactElement<ColumnProps & OptionsColumnProps>[];
    onRowClick?: (row: any) => void;
    striped?: boolean;
    type: 'card' | 'table';
    className?: string;
    hideHeaders?: boolean;
};

type MultiListWithChildComponents = React.FC<TableProps> & {
    Column: typeof Column;
    OptionsColumn: typeof OptionsColumn;
};

// export type Column = (ColumnProps) & { _type: 'Column' | 'OptionsColumn' };

const MultiList: MultiListWithChildComponents = ({
    // hasPagination,
    pageSize = 10,
    data,
    startPage = 0,
    children,
    onRowClick,
    striped,
    className,
    type,
    hideHeaders,
}) => {
    const [sortByKey, setSortByKey] = useState('');
    const [sortByAsc, setSortByAsc] = useState(true);
    const [page, setPageUnsafe] = useState(startPage);

    const lastPage = Math.ceil(data.length / pageSize - 1);
    const columns = children.map((c) => ({ ...c.props, _type: c.type === Column ? 'Column' : 'OptionsColumn' }));

    const setPage = (pageNumber: number) => {
        if (pageNumber < 0) return setPageUnsafe(0);
        if (pageNumber > lastPage) return setPageUnsafe(lastPage);
        return setPageUnsafe(pageNumber);
    };

    const getTableData = () => {
        let d = orderBy(data, [sortByKey], [sortByAsc ? 'asc' : 'desc']);

        if (pageSize > 0) {
            d = d.slice(pageSize * page, pageSize * page + pageSize);
        }
        return d;
    };

    const tableProps = {
        className,
        striped,
        sortByKey,
        sortByAsc,
        setSortByKey,
        setSortByAsc,
        onRowClick,
        data: getTableData(),
        columns,
        hideHeaders,
    };

    return (
        <>
            {type === 'table' && <MultiListTable {...tableProps} />}
            {type === 'card' && <MultiListCard {...tableProps} />}
            {pageSize > 0 && <MultiListPagination lastPage={lastPage} page={page} setPage={setPage} />}
        </>
    );
};

MultiList.Column = Column;
MultiList.OptionsColumn = OptionsColumn;

export default MultiList;
